import { CSSObject } from 'foundations-theming/utils';

export const getPlaceholderStyles = (styles: CSSObject): CSSObject => {
  return {
    '::-webkit-input-placeholder': {
      ...styles,
    },
    '::-moz-placeholder': {
      opacity: 1,
      ...styles,
    },
    ':-ms-input-placeholder': {
      ...styles,
    },
  };
};
